export const platformSessionEn = {
  houseStatusActive: 'Active',
  houseStatusSuspended: 'Suspended',
  godPlatformConfig: 'Platform config',
  platformSecuritySection: 'Session & security',
  sessionIdleTimeout: 'Auto sign-out when idle',
  sessionIdleHint:
    'After this much inactivity, users get a warning and can stay signed in. Default: 30 min. Any tap or click resets the timer.',
  sessionIdleWarnTitle: 'Session about to expire',
  sessionIdleWarnBody: 'You’ve been inactive. Stay signed in or you’ll be signed out soon.',
  sessionIdleExtend: 'Stay signed in',
  sessionIdleSignOut: 'Sign out now',
  minutesShort: 'min',
  savePlatformConfig: 'Save platform settings',
  platformConfigSaving: 'Saving…',
  platformConfigSaved: 'Platform settings saved',
  platformConfigSaveFailed: 'Could not save platform settings',
  houseConfigSection: 'House settings',
  godConfigTabGeneral: 'General',
  godConfigTabHouse: 'House',
  godHouseConfigScopeHint:
    'Select a house from your account menu to edit play windows, limits, and lottery source for that house.',
  allHouses: 'Houses',
  audit: 'Audit',
  integrity: 'Integrity',
  flags: 'Feature flags',
};

export const platformSessionEs = {
  houseStatusActive: 'Activa',
  houseStatusSuspended: 'Suspendida',
  godPlatformConfig: 'Config plataforma',
  platformSecuritySection: 'Sesión y seguridad',
  sessionIdleTimeout: 'Cierre automático por inactividad',
  sessionIdleHint:
    'Tras este tiempo sin actividad se avisa y luego se cierra la sesión. Por defecto: 30 min. Cualquier toque o clic reinicia el contador.',
  sessionIdleWarnTitle: 'La sesión está por cerrarse',
  sessionIdleWarnBody: 'Llevas tiempo inactivo. Quédate conectado o se cerrará la sesión pronto.',
  sessionIdleExtend: 'Seguir conectado',
  sessionIdleSignOut: 'Cerrar sesión ahora',
  minutesShort: 'min',
  savePlatformConfig: 'Guardar ajustes de plataforma',
  platformConfigSaving: 'Guardando…',
  platformConfigSaved: 'Ajustes de plataforma guardados',
  platformConfigSaveFailed: 'No se pudieron guardar los ajustes',
  houseConfigSection: 'Ajustes de casa',
  godConfigTabGeneral: 'General',
  godConfigTabHouse: 'Casa',
  godHouseConfigScopeHint:
    'Elige una casa en tu menú de cuenta para editar horarios, límites y fuente de lotería de esa banca.',
  allHouses: 'Casas',
  audit: 'Auditoría',
  integrity: 'Integridad',
  flags: 'Flags de funciones',
};
